module.exports = __webpack_public_path__ + "static/media/web-bg.99bd4ebe.svg";